import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';

import { Matter } from '../../../models/matter';

import { AlertService } from '../../../services/common/alert.service';
import { MatterService } from '../../../services/matters/matter.service';
import { MatterStoreService } from '../../../services/matters/matter-store.service';

@Component({
  selector: 'app-matter-edit-form',
  templateUrl: './matter-edit-form.component.html',
  styleUrls: ['./matter-edit-form.component.css'],
})
export class MatterEditFormComponent implements OnInit {
  @Input() matter_id: number;

  /**
   * Save Success
   */
  @Output() saveMatterEvent = new EventEmitter<object>();

  matter: Matter;

  formOptions: any;

  loading: boolean = true;

  formSubmitting: boolean = false;

  saveSuccess: boolean = false;

  constructor(private alertService: AlertService, private matterService: MatterService, private matterStoreService: MatterStoreService) {}

  // Component lifecycle functions
  ngOnInit() {}

  ngOnChanges(changes: any) {
    if (changes.matter_id.currentValue)
      this.matterService.formOptions(this.matter_id).then((response_json) => {
        this.formOptions = response_json;
        this.matterService.getEdit(this.matter_id).then((matter) => {
          this.loading = false;
          this.matter = matter;
          if (!this.matter.custom_name) this.matter.use_case_name = true;
        });
      });
  }

  // Component functions
  saveMatter() {
    this.formSubmitting = true;
    this.matterService
      .updateMatter(this.matter)
      .then((response_json) => {
        this.formSubmitting = false;
        this.saveSuccess = true;
        this.saveMatterEvent.emit({status: this.saveSuccess});
        //if(response_json[0].id){
        this.alertService.alert_status_success('Updated successfully');
        this.matterStoreService.matterSidebarComponent!.sidebarExpand.edit_matter = false;
        if (this.matterStoreService.billingRecordTimeComponent) this.matterStoreService.billingRecordTimeComponent.loadFormOptions();
        if (this.matterStoreService.matterShowComponent) this.matterStoreService.matterShowComponent.loadMatterInfo();
        //}else
        //	this.alertService.alert_status_danger('Error in updation');
      })
      .catch((err) => {
        this.formSubmitting = false;
        console.error(err);
        this.alertService.alert_status_danger('Error in updation');
      });
  }

  updateRateTypes() {
    this.matterService.getRateTypes(this.matter.matter_type_id).then((response_json) => {
      let rate_types: Array<any> = [];
      for (let rate_type of response_json)
        rate_types.push({
          id: rate_type.id,
          label: rate_type.name,
          value: rate_type.id,
        });
      this.formOptions.rate_types = rate_types;
    });
  }
}
